(() => {
  const routesRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";

  const prefillFromUrl = () => {
    const pageType = new URLSearchParams(window.location.search).get("id");
    if (!pageType || pageType.length < 2) return;

    document.querySelectorAll("[data-contact-prefill-url]").forEach((textarea) => {
      textarea.value = "I am enquiring about " + pageType.replaceAll("-", " ");
    });
  };

  const isFileUrl = (value) => {
    if (!value || typeof value !== "string") return false;
    const trimmed = value.trim();
    return (
      trimmed.indexOf("/uploads/") !== -1 ||
      trimmed.indexOf("/cdn/shop") !== -1 ||
      trimmed.indexOf("cdn.shopify") !== -1 ||
      trimmed.indexOf("shopifycdn.com") !== -1 ||
      /^https?:\/\//i.test(trimmed)
    );
  };

  const extractUrls = (properties) => {
    if (!properties) return [];
    const values = Array.isArray(properties)
      ? properties.map((entry) => (Array.isArray(entry) ? entry[1] : entry))
      : Object.keys(properties).map((key) => properties[key]);
    return values.map((value) => (typeof value === "string" ? value.trim() : "")).filter(isFileUrl);
  };

  const withHttps = (url) => {
    const trimmed = url.trim();
    if (/^https?:\/\//i.test(trimmed)) return trimmed;
    if (trimmed.startsWith("//")) return "https:" + trimmed;
    return "https://" + trimmed;
  };

  const sanitizeOrderPrefix = (value) =>
    String(value || "")
      .trim()
      .replace(/^#+/, "")
      .replace(/[^a-zA-Z0-9_-]+/g, "-")
      .replace(/^-+|-+$/g, "")
      .slice(0, 40);

  const fileExtension = (file) => {
    const fromName = ((file && file.name) || "").match(/\.([a-z0-9]+)$/i);
    if (fromName) return fromName[1].toLowerCase() === "jpeg" ? "jpg" : fromName[1].toLowerCase();
    if (file && file.type === "image/png") return "png";
    if (file && file.type === "image/webp") return "webp";
    if (file && file.type === "image/gif") return "gif";
    return "jpg";
  };

  const namedUploadFile = (file, index, prefix) => {
    const ext = file.type === "image/jpeg" ? "jpg" : fileExtension(file);
    const name = (prefix ? prefix + "_" : "") + "photo-" + (index + 1) + "." + ext;
    return new File([file], name, { type: file.type, lastModified: file.lastModified || Date.now() });
  };

  const isSafePhotoUrl = (url) => {
    try {
      const parsed = new URL(withHttps(url));
      return (
        parsed.protocol === "https:" &&
        (parsed.hostname === "cdn.shopify.com" || parsed.hostname.endsWith(".shopifycdn.com"))
      );
    } catch (error) {
      return false;
    }
  };

  const photoDownloadPage = () => window.location.origin + window.location.pathname;

  const formatPhotoUrls = (urls, files) =>
    urls
      .map((url, index) => {
        const href = withHttps(url);
        const name = files && files[index] && files[index].name ? files[index].name : "photo-" + (index + 1) + ".jpg";
        const downloadLink =
          photoDownloadPage() +
          "?refund_photo=" +
          encodeURIComponent(name) +
          "&refund_file=" +
          encodeURIComponent(href);
        return name + ": " + downloadLink;
      })
      .join("\n");

  const downloadNamedPhoto = async (url, filename) => {
    const response = await fetch(url, { mode: "cors" });
    if (!response.ok) throw new Error("Could not download photo.");
    const blob = await response.blob();
    const objectUrl = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = objectUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    setTimeout(() => URL.revokeObjectURL(objectUrl), 2000);
  };

  const initPhotoDownload = () => {
    const params = new URLSearchParams(window.location.search);
    const filename = (params.get("refund_photo") || "").replace(/[/\\]/g, "");
    const fileUrl = params.get("refund_file");
    if (!filename || !fileUrl || !isSafePhotoUrl(fileUrl)) return;

    const href = withHttps(fileUrl);
    const overlay = document.createElement("div");
    overlay.className = "contact-photo-download";
    overlay.innerHTML =
      '<div class="contact-photo-download__card">' +
      "<p>Save this photo as <strong>" +
      filename.replace(/</g, "") +
      "</strong></p>" +
      '<img alt="' +
      filename.replace(/"/g, "") +
      '" src="' +
      href.replace(/"/g, "") +
      '">' +
      '<button type="button" class="btn btn--orange contact-photo-download__save"><span class="btn-inner">Save photo</span></button>' +
      "</div>";
    document.body.appendChild(overlay);

    const close = () => overlay.remove();
    const save = async () => {
      try {
        await downloadNamedPhoto(href, filename);
      } catch (error) {
        window.open(href, "_blank", "noopener");
      }
      close();
    };

    overlay.querySelector(".contact-photo-download__save").addEventListener("click", save);
    overlay.addEventListener("click", (event) => {
      if (event.target === overlay) close();
    });
  };

  const refreshCartUi = (cart) => {
    if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: "contact-form", cartData: cart });
    }
  };

  const clearUploadItems = async (variantId) => {
    const cartResponse = await fetch(routesRoot + "cart.js", { headers: { Accept: "application/json" } });
    const cart = await cartResponse.json();
    const updates = {};
    (cart.items || []).forEach((item) => {
      const isUploadItem =
        (variantId && Number(item.variant_id) === Number(variantId)) ||
        item.handle === "refund-image-uploader";
      if (isUploadItem) updates[item.key] = 0;
    });
    if (!Object.keys(updates).length) return cart;

    const updateResponse = await fetch(routesRoot + "cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ updates }),
    });
    const updatedCart = await updateResponse.json();
    refreshCartUi(updatedCart);
    return updatedCart;
  };

  const compressImage = (file) =>
    new Promise((resolve) => {
      if (!file.type.startsWith("image/") || file.type === "image/gif" || file.size < 350000) {
        resolve(file);
        return;
      }

      const image = new Image();
      const objectUrl = URL.createObjectURL(file);
      image.onload = () => {
        const maxDim = 1600;
        const scale = Math.min(1, maxDim / Math.max(image.width, image.height));
        const canvas = document.createElement("canvas");
        canvas.width = Math.round(image.width * scale);
        canvas.height = Math.round(image.height * scale);
        canvas.getContext("2d").drawImage(image, 0, 0, canvas.width, canvas.height);
        canvas.toBlob(
          (blob) => {
            URL.revokeObjectURL(objectUrl);
            if (!blob) {
              resolve(file);
              return;
            }
            resolve(new File([blob], file.name.replace(/\.[^.]+$/, ".jpg"), { type: "image/jpeg" }));
          },
          "image/jpeg",
          0.8
        );
      };
      image.onerror = () => {
        URL.revokeObjectURL(objectUrl);
        resolve(file);
      };
      image.src = objectUrl;
    });

  const initFileUpload = (root) => {
    const form = root.querySelector("#ContactForm, form[action*='/contact']");
    const fileInput = root.querySelector("[data-contact-file-input]");
    if (!form || !fileInput || form.dataset.contactFormBound === "true") return;

    form.dataset.contactFormBound = "true";

    const drop = root.querySelector("[data-contact-file-drop]");
    const previews = root.querySelector("[data-contact-file-previews]");
    const urlsField = root.querySelector("[data-contact-file-urls]");
    const statusEl = root.querySelector("[data-contact-file-status]");
    const submitButton = form.querySelector('button[type="submit"]');
    const maxFiles = Number(fileInput.dataset.maxFiles || 3);
    const maxFileBytes = Number(fileInput.dataset.maxFileSize || 25 * 1024 * 1024);
    const maxFileMb = Math.round(maxFileBytes / (1024 * 1024));
    const uploadRoot = root.querySelector("[data-upload-variant-id]") || form.closest("[data-upload-variant-id]");
    const variantId = uploadRoot?.dataset.uploadVariantId;
    const orderNumberField = form.querySelector('[name="contact[order_number]"]')
      || form.querySelector('input[name*="order_number" i]')
      || form.querySelector('input[name*="order-number" i]');
    let selectedFiles = [];
    let uploadedUrls = [];
    let uploadedPrefix = null;
    let uploadPromise = Promise.resolve();

    const getOrderNumberPrefix = () => {
      const field =
        orderNumberField ||
        form.querySelector('[name="contact[order_number]"]') ||
        form.querySelector('input[name*="order" i]');
      return sanitizeOrderPrefix(field && field.value);
    };

    const setStatus = (message, isError) => {
      if (!statusEl) return;
      statusEl.textContent = message || "";
      statusEl.classList.toggle("contact-file-upload__status--error", Boolean(isError && message));
    };

    const namedSelectedFiles = () =>
      selectedFiles.map((file, index) => namedUploadFile(file, index, getOrderNumberPrefix()));

    const applyUrlsToForm = (urls, files) => {
      uploadedUrls = urls;
      if (urlsField) urlsField.value = urls.length ? formatPhotoUrls(urls, files) : files && files.length ? files.map((file) => file.name).join("\n") : "";
    };

    const syncFileInput = () => {
      const transfer = new DataTransfer();
      selectedFiles.forEach((file) => transfer.items.add(file));
      fileInput.files = transfer.files;
    };

    const renderPreviews = () => {
      if (!previews) return;
      previews.innerHTML = "";
      selectedFiles.forEach((file, index) => {
        const wrap = document.createElement("div");
        wrap.className = "contact-file-upload__preview";
        const img = document.createElement("img");
        img.alt = file.name;
        img.src = URL.createObjectURL(file);
        img.onload = () => URL.revokeObjectURL(img.src);
        const remove = document.createElement("button");
        remove.type = "button";
        remove.className = "contact-file-upload__remove";
        remove.setAttribute("aria-label", "Remove " + file.name);
        remove.textContent = "×";
        remove.addEventListener("click", () => {
          selectedFiles.splice(index, 1);
          syncFileInput();
          renderPreviews();
          uploadPromise = uploadPhotos().catch((error) => {
            setStatus(error.message || "Photo upload failed.", true);
            if (submitButton) submitButton.disabled = false;
            return [];
          });
        });
        wrap.append(img, remove);
        previews.appendChild(wrap);
      });
    };

    const addFiles = (fileList) => {
      let rejectedSize = false;
      let rejectedCount = false;

      Array.from(fileList || [])
        .filter((file) => file.type.startsWith("image/"))
        .forEach((file) => {
          if (file.size > maxFileBytes) {
            rejectedSize = true;
            return;
          }
          const exists = selectedFiles.some(
            (current) => current.name === file.name && current.size === file.size && current.lastModified === file.lastModified
          );
          if (!exists) selectedFiles.push(file);
        });

      if (selectedFiles.length > maxFiles) {
        selectedFiles = selectedFiles.slice(0, maxFiles);
        rejectedCount = true;
      }

      syncFileInput();
      renderPreviews();
      uploadedUrls = [];
      uploadedPrefix = null;
      applyUrlsToForm([], namedSelectedFiles());

      if (rejectedSize) {
        setStatus("Each image must be " + maxFileMb + "MB or less.", true);
      } else if (rejectedCount) {
        setStatus("You can add up to " + maxFiles + " photos.", true);
      }

      uploadPromise = uploadPhotos().catch((error) => {
        setStatus(error.message || "Photo upload failed.", true);
        if (submitButton) submitButton.disabled = false;
        return [];
      });
    };

    const uploadPhotos = async () => {
      if (!selectedFiles.length) {
        applyUrlsToForm([]);
        uploadedPrefix = null;
        setStatus("");
        return [];
      }
      if (!variantId) {
        throw new Error(
          "Photos could not be uploaded. Please email 2–3 images to dispatch@turfrey.co.nz with your order number."
        );
      }

      setStatus("Uploading photos…");
      if (submitButton) submitButton.disabled = true;

      const prefix = getOrderNumberPrefix();
      const compressed = [];
      for (let index = 0; index < selectedFiles.length; index++) {
        compressed.push(await compressImage(namedUploadFile(selectedFiles[index], index, prefix)));
      }

      const body = new FormData();
      body.append("id", variantId);
      body.append("quantity", "1");
      compressed.forEach((file, index) => {
        body.append("properties[_Refund photo " + (index + 1) + "]", file, file.name);
      });

      const addResponse = await fetch(routesRoot + "cart/add.js", {
        method: "POST",
        headers: { Accept: "application/json" },
        body,
      });
      const added = await addResponse.json();
      if (!addResponse.ok) {
        throw new Error(added.description || added.message || "Photo upload failed.");
      }

      const item = Array.isArray(added) ? added[0] : added.items && added.items[0] ? added.items[0] : added;
      let urls = extractUrls(item && item.properties);

      if (!urls.length) {
        const cartResponse = await fetch(routesRoot + "cart.js", { headers: { Accept: "application/json" } });
        const cart = await cartResponse.json();
        const cartItem = (cart.items || []).find((entry) => String(entry.key) === String(item.key) || Number(entry.id) === Number(variantId));
        urls = extractUrls(cartItem && cartItem.properties);
      }

      await clearUploadItems(variantId);

      if (!urls.length) {
        throw new Error(
          "Photos could not be uploaded. Please email 2–3 images to dispatch@turfrey.co.nz with your order number."
        );
      }

      applyUrlsToForm(urls, compressed);
      uploadedPrefix = prefix;
      setStatus("Photos attached (" + urls.length + ").");
      if (submitButton) submitButton.disabled = false;
      return urls;
    };

    if (drop && drop.tagName !== "LABEL") {
      drop.addEventListener("click", () => fileInput.click());
    }
    if (drop) {
      drop.addEventListener("dragover", (event) => event.preventDefault());
      drop.addEventListener("drop", (event) => {
        event.preventDefault();
        addFiles(event.dataTransfer.files);
      });
    }

    fileInput.addEventListener("change", () => addFiles(fileInput.files));

    if (orderNumberField) {
      orderNumberField.addEventListener("input", () => {
        if (!selectedFiles.length) return;
        applyUrlsToForm(uploadedUrls, namedSelectedFiles());
      });
    }

    form.addEventListener("submit", async (event) => {
      if (form.dataset.photosReady === "true") return;
      if (!selectedFiles.length && fileInput.files && fileInput.files.length) {
        addFiles(fileInput.files);
      }
      if (!selectedFiles.length) return;

      event.preventDefault();
      try {
        await uploadPromise;
        const prefix = getOrderNumberPrefix();
        if (!uploadedUrls.length || uploadedPrefix !== prefix) {
          uploadedUrls = await uploadPhotos();
        }
        if (!uploadedUrls.length) {
          throw new Error("Photos could not be uploaded.");
        }

        await clearUploadItems(variantId);

        form.dataset.photosReady = "true";
        if (typeof form.requestSubmit === "function") form.requestSubmit(submitButton);
        else form.submit();
      } catch (error) {
        setStatus(error.message || "Photo upload failed.", true);
        if (submitButton) submitButton.disabled = false;
      }
    });
  };

  const init = () => {
    initPhotoDownload();
    prefillFromUrl();
    document.querySelectorAll(".contact-formsection").forEach((section) => {
      const variantId = section.querySelector("[data-upload-variant-id]")?.dataset.uploadVariantId;
      if (variantId || section.querySelector(".contact-form__success")) {
        clearUploadItems(variantId).catch(() => {});
      }
      initFileUpload(section);
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", (event) => {
    if (event.target && event.target.classList.contains("contact-formsection")) {
      initFileUpload(event.target);
    }
  });
})();
